@import '../../../globals/main.scss';

pn-dropdown-with-multi-input-rows {
  .dropdown-with-multi-input-element {
    &__row {
      margin-bottom: 1rem;
    }

    &__delete {
      display: flex;
      gap: 1rem;
      margin-bottom: 1rem;
      padding: 1rem;
      background-color: $gray25;

      pn-button {
        margin-top: 0.9rem;
      }
    }

    &__label-row {
      display: flex;
      gap: 1rem;
    }

    &__label {
      width: 30%;
      font-size: 0.875em;
      color: #5e554a;
    }
  }

  
  .sum-row {
    display: flex;
    justify-content: space-between;
  }
  
  .dropdown-with-multi-input-element__dropdown {
    display: inline-flex;
    align-items: center;
  }
  
  small {
    max-width: 70%;
    margin: 1rem;
    align-self: center;
    position: relative;
    top: 1rem;
  }
  
  .dropdown-with-multi-input-element__row 
  .dropdown-with-multi-input-element__dropdown 
  .pn-row-select-dropdown 
  .pn-select 
  .pn-select-input
  .pn-select-content {
    width: 18rem;
  }

}
